export default (val, digits = 2) => {
  if (typeof val === 'number') {
    return val.toFixed(digits);
  }
  return val;
};
